import React, { useEffect, useState } from "react";
import { useDrop } from "react-dnd";
import "./column.css";
import Task from "./tasks";

const Column = ({
  idcolumn,
  name,
  tasks = [],
  moveTask,
  vltotalColumn,
  onDelete,
  onCloseSalve,
  // onArchive ,
}) => {
  const [dragOverIndex, setDragOverIndex] = useState(-1);

  useEffect(() => {
    return () => {
      setDragOverIndex(-1);
    };
  }, []);

  // Timeout de segurança para resetar o estado
  useEffect(() => {
    if (dragOverIndex !== -1) {
      const timeout = setTimeout(() => {
        setDragOverIndex(-1);
      }, 500); // Reset após 0,5 segundos se não for limpo

      return () => clearTimeout(timeout);
    }
  }, [dragOverIndex]);

  // Configura o comportamento de drop da coluna
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: "task",
    hover: (item, monitor) => {
      if (!monitor.isOver({ shallow: true })) {
        setDragOverIndex(-1);
        return;
      }

      const clientOffset = monitor.getClientOffset();
      if (!clientOffset) {
        setDragOverIndex(-1);
        return;
      }

      const dropY = clientOffset.y;
      const taskElements = document.querySelectorAll(
        `[data-column-id="${idcolumn}"] .task-item`
      );

      let newIndex = tasks.length;
      // Encontra a posição de drop
      for (let i = 0; i < taskElements.length; i++) {
        const rect = taskElements[i].getBoundingClientRect();
        const taskCenterY = rect.top + rect.height / 2;

        if (dropY < taskCenterY) {
          newIndex = i;
          break;
        }
      }

      if (newIndex !== dragOverIndex) {
        setDragOverIndex(newIndex);
      }
    },
    drop: (item, monitor) => {
      console.log("Drop realizado");
      moveTask(item.id, item.sourceColumnId, idcolumn, dragOverIndex);
      setDragOverIndex(-1);
    },
    end: (item, monitor) => {
      // Garante que o estado seja resetado quando o drag termina
      console.log("Drag terminado");
      setDragOverIndex(-1);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  return (
    <div
      ref={drop}
      data-column-id={idcolumn}
      className={`column-drop-zone ${
        isOver && canDrop ? "drop-target-active" : ""
      }`}
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor:
          isOver && canDrop ? "#f0f0f0" : "transparent",
        boxShadow:
          isOver && canDrop ? "3" : "none",
        border:
          isOver && canDrop ? "2px dashed #007bff" : "2px dashed transparent",
        borderRadius: "8px",
        transition: "all 0.2s ease",
      }}
    >

      {/* Contêiner rolável para as tarefas */}
      <div className="tasks-container">
        {tasks.length > 0 ? (
          tasks.map((task, index) => (
            <Task
              key={`${task.idbudget}-${index}`} // Garante que a chave seja única
              id={task.idbudget}
              title={task.campanha}
              task={task}
              sourceColumnId={idcolumn}
              onDelete={() => onDelete(task.idbudget, idcolumn)}
              onCloseSalve={onCloseSalve}
              column={name}
              // onArchive={() => onArchive(task.idbudget, idcolumn)}
              dragOverIndex={dragOverIndex}
              taskIndex={index}
            />
          ))
        ) : (
          <span style={{ fontSize: "15px" }}>
            Ainda não há orçamento associado a esta coluna
          </span>
        )}
      </div>
    </div>
  );
};

export default Column;
